module.exports = __webpack_public_path__ + "static/img/certification.f1b2bc8a.png";